import { render } from "./GiftcardTypeSelector.vue?vue&type=template&id=bea666b0"
import script from "./GiftcardTypeSelector.vue?vue&type=script&lang=js"
export * from "./GiftcardTypeSelector.vue?vue&type=script&lang=js"

import "./GiftcardTypeSelector.vue?vue&type=style&index=0&id=bea666b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__